import * as React from 'react';
import { SVGProps } from 'react';

const IconFileFontSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.1 3H19.9l1.223 5.5H18v-1A1.5 1.5 0 0 0 16.5 6H14v12h2v3H8v-3h2V6H7.5A1.5 1.5 0 0 0 6 7.5v1H2.877L4.099 3ZM4.9 4l-.777 3.5H5A2.5 2.5 0 0 1 7.5 5H11v14H9v1h6v-1h-2V5h3.5A2.5 2.5 0 0 1 19 7.5h.877L19.099 4H4.901Z"
    />
  </svg>
);
export default IconFileFontSizeM;
